import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { isDevToolsEnabled } from '../utils/devTools';

const DEFAULT_LOADING = {
  forceGlobal: false,
  forceProposal: false,
  proposalProgress: 62,
  proposalPhase: null,
};

const DevToolsContext = createContext(null);

export function DevToolsProvider({ children }) {
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoadingState] = useState(DEFAULT_LOADING);

  useEffect(() => {
    setEnabled(isDevToolsEnabled());
  }, []);

  const setLoadingOverride = useCallback((key, value) => {
    setLoadingState(prev => ({ ...prev, [key]: value }));
  }, []);

  const resetLoadingOverrides = useCallback(() => {
    setLoadingState(DEFAULT_LOADING);
  }, []);

  const value = useMemo(() => ({
    enabled,
    setEnabled,
    loading,
    setLoadingOverride,
    resetLoadingOverrides,
  }), [enabled, loading, setLoadingOverride, resetLoadingOverrides]);

  return (
    <DevToolsContext.Provider value={value}>
      {children}
    </DevToolsContext.Provider>
  );
}

export function useDevTools() {
  const ctx = useContext(DevToolsContext);
  if (!ctx) {
    return {
      enabled: false,
      setEnabled: () => {},
      loading: DEFAULT_LOADING,
      setLoadingOverride: () => {},
      resetLoadingOverrides: () => {},
    };
  }
  return ctx;
}
